import { render, staticRenderFns } from "./TrainingDuration.vue?vue&type=template&id=42e6e464&"
import script from "./TrainingDuration.vue?vue&type=script&lang=js&"
export * from "./TrainingDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports